<template>
	<div class="open-account-bank">
		<h4 class="h4_title">高级行情状态</h4>
		<van-cell-group style="padding-bottom: 2px;">
			<van-cell title="是否开启" :value="advanced_quotes==1?'开启':'关闭'" />
			<van-cell title="等级" :value="advanced_quotes_type==2?'高级行情':''" />
			<van-cell title="到期日" :value="advanced_quotes_enddate" />
			<div class="common_block">
				<van-button type="warning" block @click="goGood">购买</van-button>
			</div>
		</van-cell-group>
		<h4 class="h4_title">购买记录</h4>
		<van-cell-group v-for="p in list" :key="p.qts_order_id" style="margin-bottom: 10px;">
			<van-cell title="商品名称" :value="p.qts_goods_name" />
			<van-cell title="购买价格" :value="p.buy_price" />
			<van-cell title="购买方式" :value="p.type" />
			<van-cell title="到期日" :value="p.end_date" />
			<van-cell title="订单时间" :value="p.insert_time" />
		</van-cell-group>
	</div>
</template>

<script>
	export default {
		name: 'qts_index',
		data() {
			return {
				token: '',
				advanced_quotes: '',
				advanced_quotes_type: '',
				advanced_quotes_enddate: '',
				list:[]
			}
		},
		mounted() {
			
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.token = this.$route.query.token
			}
			this.getData()
			this.getList()
		},
		methods: {
			getData() {
				this.$axios({
					method: 'post',
					url: 'qts_qts/index', 
					data: {
						token: this.token
					}
				}).then ((res) => {
					if (res.success) {
						this.advanced_quotes = res.data.advanced_quotes
						this.advanced_quotes_type = res.data.advanced_quotes_type
						this.advanced_quotes_enddate = res.data.advanced_quotes_enddate

					}else{
						this.$toast.fail(res.error_text)
					}
				})
			},
			getList() {
				this.$axios({
					method: 'post',
					url: 'qts_qts/orderlist', 
					data: {
						token: this.token
					}
				}).then ((res) => {
					if (res.success) {
						this.list = res.data
						
					}else{
						this.$toast.fail(res.error_text)
					}
				})
			},
			goGood(){
				this.$router.push('/qts/goodslist?token=' + this.token)
			}
		},
	}
</script>